export default __webpack_public_path__ + "static/media/Crop.354fbd10.svg";